import * as React from "react";
import "../assets/vendors/style";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Button, Checkbox, Form, Input, message } from "antd";
import { useStore } from "react-redux";
import { storeNamePage } from "../appRedux/actions/Auth";
import { loadLoginLoader } from "../appRedux/actions/CommonData";
// import TS_APP_BASE_WEB_URL from '../Services/DataServices';
// import TS_APP_BASE_LOCAL_URL from '../Services/DataServices';
import { userStore } from "../appRedux/actions/index";
import { useHistory, useLocation } from "react-router-dom";
import Spinner from "reactstrap/lib/Spinner";
import { useCookies } from "react-cookie";
import { env } from "../env";
import { BUS_PARENT_SITE, BUS_SITE_LOCAL, BUS_SITE_LOCAL_IP } from "../constants/StoreSetting";
import BuzzTillBannerLogo from "../assets/images/buzztill_logo_text_only.png"
import { checkIsWeb, postDataToApp } from "../appRedux/actions/MobAppFn";
import { PostAppTypes } from "../constants/MobAppConstants";

message.config({
  duration: 1,
  top: 24,
});

const { REACT_APP_BUS_NAME, REACT_APP_BUS_SITE_APP, REACT_APP_BUS_SITE_SECOND }  = env
const TS_APP_BASE_WEB_URL = `${REACT_APP_BUS_SITE_APP}`;
const TS_APP_BASE_LOCAL_URL = `${BUS_SITE_LOCAL}`;
const TS_APP_BASE_LOCAL_IP = `${BUS_SITE_LOCAL_IP}`;
const { TS_COOKIE_BASE_DOMAIN } = env;

const SignInForm = () => {
  const [form] = Form.useForm();
  const [loader, setloader] = React.useState();
  //const useEffect = useEffect();
  const store = useStore();
  const [cookies, setCookie] = useCookies(["storeName", "storeHash", "reqNo"]);
  // let storeName = localStorage.getItem("storeName");
  // let storeHash = localStorage.getItem("storeHash");

  // if (storeName != null) {
  //   form.setFieldsValue({ storeName: storeName });
  //   message.success("You already signed in to " + storeName);
  // }
  interface authState {
    auth: any;
  }
  interface commonState {
    commonData: any;
  }
  interface loaderStateInterface {
    commonConfigs: any;
  }
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const FormItem = Form.Item;
  const dispatch = useDispatch();
  const history = useHistory();
  // const [refererValue, setrefererValue] = React.useState(false);
  const selectAuth = (state: authState) => state.auth.storeVariable;
  const commonDataRedux = (state: commonState) => state && state.commonData ? state.commonData : false;
  const loaderRedux = (state: loaderStateInterface) => state.commonConfigs;

  const [localStorageItems, setLocalStorageItems] = React.useState<{ key: string; value: string }[]>([]);

  const urlParams = new URLSearchParams(window.location.search)
  const is_mob_app = urlParams.get('ismobapp')

  const storeredux = useSelector(selectAuth);
  const commonRedux = useSelector(commonDataRedux);
  const loaderSelector = useSelector(loaderRedux);
  let query = useQuery();
  let cookie_StoreName = cookies.storeName;
  let cookie_StoreHash = cookies.storeHash;
  let cookie_reqNo = cookies.reqNo;
  useEffect(() => {
    // loadLocalStorageItems();
    if(!checkIsWeb().exist){
      postDataToApp(PostAppTypes.LOGOUT, true)
    }
    let allow = is_mob_app ? false : checkIsWeb().exist
    if(allow){
      const baseURL = window.location.origin;

    var isCookieSet = cookie_StoreName && cookie_StoreHash ? true : false;
    var cookieStoreName =
      storeredux && storeredux.storeName
        ? storeredux.storeName
        : cookie_StoreName;
    var cookieStoreHash =
      storeredux && storeredux.storeHash
        ? storeredux.storeHash
        : cookie_StoreHash;
    var cookieReqNo =
      storeredux && storeredux.reqNo
        ? storeredux.reqNo
        : cookie_reqNo;

    if (TS_APP_BASE_LOCAL_URL != baseURL && baseURL != TS_APP_BASE_WEB_URL && TS_APP_BASE_LOCAL_IP != baseURL) {
      const url = window.location.href;
      let domainName = "";
      try {
        domainName = new URL(url).hostname.split(".")[0];
        if (!domainName) {
           window.location.href = TS_APP_BASE_WEB_URL + "/signin";
        } else {
          if (!cookieStoreName && !cookieStoreHash && !isCookieSet) {
            const storeObj = {
              storeName: domainName,
            };
            dispatch(userStore(storeObj, form, history));
          }
        }
      } catch (errorCatch) {
        // Handle errors when URL is not valid or cannot be parsed
        //message.error(`Error: ${errorCatch}`);
        
      }
     
    }

    const isReloadPage = query.get("findStore");

    //if(isReloadPage==null || isReloadPage=='' || isReloadPage == undefined)
    //{

    if (cookieStoreName && cookieStoreHash) {
      if (!isCookieSet) {
        setCookie("storeName", cookieStoreName, {
          domain: TS_COOKIE_BASE_DOMAIN,
          path: "/",
        });
        setCookie("storeHash", cookieStoreHash, {
          domain: TS_COOKIE_BASE_DOMAIN,
          path: "/",
        });
        setCookie("reqNo", cookieReqNo, {
          domain: TS_COOKIE_BASE_DOMAIN,
          path: "/",
        });
      }
      storeNamePage(cookieStoreName, cookieStoreHash);
    }
    //}
    }
  }, [
    storeredux != null && storeredux.storeName ? storeredux.storeName : ""
    ,commonRedux.loading,
  ]); // storeredux.storeName, commonRedux.loading

  // useEffect(() => {
  //   const originalConsoleLog = console.log; // Save the original console.log function

  //   console.log = (...args: any[]) => {
  //     // Intercept console.log and append the logs to a div
  //     const logElement = document.getElementById('log');
  //     if (logElement) {
  //       logElement.innerHTML += args.map(arg => JSON.stringify(arg)).join(' ') + '<br>';
  //     }

  //     // Call the original console.log
  //     originalConsoleLog.apply(console, args);
  //   };

  //   // Cleanup function
  //   return () => {
  //     console.log = originalConsoleLog; // Restore the original console.log on component unmount
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleStorageChange = (event: StorageEvent) => {
  //     if (event.key === 'localStorageKey') {
  //       loadLocalStorageItems()
  //     }
  //   };

  //   window.addEventListener('storage', handleStorageChange);

  //   return () => {
  //     // Clean up the event listener when the component is unmounted
  //     window.removeEventListener('storage', handleStorageChange);
  //   };
  // }, []);

  // const loadLocalStorageItems = () => {
  //   const items: { key: string; value: string }[] = [];
  //   for (let i = 0; i < localStorage.length; i++) {
  //     const key = localStorage.key(i) as string;
  //     const value = localStorage.getItem(key) as string;
  //     items.push({ key, value });
  //   }
  //   setLocalStorageItems(items);
  //   postDataToApp(PostAppTypes.DEBUG, `localStorageItems ====> ${JSON.stringify(items)}`)
  //   console.log(`logging local storage ==============>>> ${JSON.stringify(items)}`)
  // };

  const doSubmit = async (values: any) => {
    
    values.isReferer = false;
    if (form.getFieldValue("storeName") != undefined) {
      dispatch(loadLoginLoader(true));
      dispatch(userStore(values, form, history));
    } else {
      message.error("First you need to enter store name");
    }
  };

  return checkIsWeb().exist ? (
    <Form
      form={form}
      initialValues={{ remember: true }}
      name="basic"
      //onSubmit={}
      onFinish={doSubmit}
      // onFinishFailed={onFinishFailed}
      className=""
    >
      <div className="cv-signin-header ">
        {/* <img
          className="cv-signin-header-image"
          src={`${BUS_PARENT_SITE}/wp-content/uploads/2019/11/dakar-logo-150.png`}
          height="57"
        /> */}

        <img  className="cv-signin-header-image"  height="57" alt="" src={BuzzTillBannerLogo}/> 
        <h1 className="cv-signin-header-text">Sign in</h1>
      </div>

      <div className="inputgrp-div">
        <FormItem
          name="storeName"
          rules={[
            {
              required: true,
              message: "Please enter your store name.",
            },
          ]}
        >
          <Input placeholder="Store Name" className="input-form-field-custom" />
        </FormItem>
        <label className="form-label domain-name">{REACT_APP_BUS_SITE_SECOND}</label>
        </div>

      
        <FormItem>
          {loaderSelector && loaderSelector.getLoginLoader ? (
            <Button className="btn-signin btn-reversed" type="primary" htmlType="submit" disabled >
              <Spinner color="primary">Loading</Spinner>
            </Button>
          ) : (
            <Button className="btn-signin btn-reversed" type="primary" htmlType="submit">
              Next
            </Button>
          )}
        </FormItem>
      

      <FormItem name="newSignup" className="mb-0">
        <div className="custom-text-center">
          <p className="mb-0">
            Don't have an account?  
            <a href="/SignUp" className="primary-anchor br-txt"> Try {`${REACT_APP_BUS_NAME}`} for free</a>
          </p>
        </div>
      </FormItem>
    </Form>
  ) : <div>
    {/* LOLOLO<ul>
  {localStorageItems.map(item => (
    <li key={item.key}>{`${item.key}: ${item.value}`}</li>
  ))}
</ul>

<div>
      <h1>SIGN IN FORM INSIDE Console Logger</h1>
      <div id="log"></div>
    </div> */}
  </div>;
};

export default SignInForm;
